<template>
  <div>
      <el-table
        border
        :empty-text="$t('noData')"
        :data="tableData"
        style="width: 100%">
            <el-table-column
                prop="buy_user"
                :label="$t('name')"
                width="180">
            </el-table-column>
            <el-table-column
                prop="ctime"
                width="180"
                :label="$t('time')">
            </el-table-column>
            <el-table-column
                prop="order_id"
                :label="$t('orders')">
            </el-table-column>
            <el-table-column
                prop="amount"
                :label="$t('price')">
            </el-table-column>
        </el-table>

        <Pagination
            v-if="list.length>0"
            :totalPage="totalPage"
            :limit="limit"
            @changePage="handleCurrentChange"
        ></Pagination>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";

export default {
    components: {
        Pagination
    },
    data() {
        return {
            list: [],
            id: '',
            totalPage: 0,
            page: 1,
            limit: 10
        }
    },
    methods: {
        handleCurrentChange() {
            this.page += 1
            this.list()
        },
        init() {
            let data = {
                page:           this.page,
                limit:          this.limit,
                staff_user_id:  this.id
            }
            this.$api.stafforder(data, res => {
                if (res.status) {
                    this.list = res.data.list
                    this.totalPage = Math.ceil(res.data.list / this.limit) 
                }
            })
        }
    },
    created() {
        this.id = this.$route.query.id
        this.init()
    }
}
</script>

<style lang="scss" scoped>

</style>